import { lazy, Suspense } from "react";
import { Route, Routes } from "react-router";
import Loader from "../components/Loader/Loader.jsx";

const lazyComponents = {
  Overlay: lazy(() => import("../components/Overlay/Overlay.jsx")),
  MasterHeaderNavbar: lazy(
    () => import("../components/MasterHeaderNavbar/MasterHeaderNavbar.jsx")
  ),
  Layout: lazy(() => import("../layout/Layout.jsx")),
  Login: lazy(() => import("../components/Login/index.jsx")),
  StaticComponent: lazy(() => import("../components/Page/Static.jsx")),
};

const { Overlay, MasterHeaderNavbar, Layout, Login, StaticComponent } =
  lazyComponents;

const getStaticComponent = (isUseMock) => (
  <StaticComponent useMock={isUseMock} />
);

// Dashboard con carga diferida
const DashboardProtected = () => (
  <>
    <MasterHeaderNavbar />
    <Layout />
    <Overlay />
  </>
);

// Rutas protegidas con lazy loading
export const RoutesProtected = () => (
  <Suspense fallback={<Loader />}>
    <Routes>
      <Route path="/" element={<DashboardProtected />} />
      <Route path="/test" element={getStaticComponent(true)} />
      <Route
        path="/static/:tournamentId/:seasonId/:matchId"
        element={getStaticComponent(false)}
      />
    </Routes>
  </Suspense>
);

// Rutas públicas con lazy loading
export const RoutesPublic = () => (
  <Suspense fallback={<Loader />}>
    <Routes>
      <Route path="/" element={<Login />} />
      <Route path="/test" element={getStaticComponent(true)} />
      <Route
        path="/static/:tournamentId/:seasonId/:matchId"
        element={getStaticComponent(false)}
      />
    </Routes>
  </Suspense>
);
